import * as React from 'react';
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {
	Sidebar,
	SidebarContent,
	SidebarGroup,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
	SidebarRail,
} from '@/components/ui/sidebar';
import { useAuth } from '@/context/use-auth';
import { Flame } from 'lucide-react';
import { Link } from 'react-router';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const pathname = window.location.pathname;
	const { nav } = useAuth();
	// const data = {
	// 	navMain: [
	// 		{
	// 			title: 'Home',
	// 			url: '/',
	// 		},
	// 		{
	// 			title: 'Workday',
	// 			url: '/workday',
	// 		},
	// 		{
	// 			title: 'Bind Express',
	// 			url: '/bind-express/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/bind-express/mappings',
	// 					isActive: pathname?.startsWith('/bind-express/mappings'),
	// 				},
	// 				{
	// 					title: 'Locations',
	// 					url: '/bind-express/Locations',
	// 					isActive: pathname?.startsWith('/bind-express/locations'),
	// 				},
	// 				{
	// 					title: 'Lines of Business',
	// 					url: 'bind-express/lines-of-business',
	// 					isActive: pathname?.startsWith('/bind-express/lines-of-business'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'RSUI',
	// 			url: '/rsui/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/rsui/mappings',
	// 					isActive: pathname?.startsWith('/rsui/mappings'),
	// 				},
	// 				{
	// 					title: 'Locations',
	// 					url: '/rsui/locations',
	// 					isActive: pathname?.startsWith('/rsui/locations'),
	// 				},
	// 				{
	// 					title: 'Lines of Business',
	// 					url: '/rsui/lines-of-business',
	// 					isActive: pathname?.startsWith('/rsui/lines-of-business'),
	// 				},
	// 				{
	// 					title: 'Insurance Carriers',
	// 					url: '/rsui/insurance-carriers',
	// 					isActive: pathname?.startsWith('/rsui/insurance-carriers'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'Wells Fargo',
	// 			url: '/wells-fargo/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/wells-fargo/mappings',
	// 					isActive: pathname?.startsWith('/wells-fargo/mappings'),
	// 				},
	// 				{
	// 					title: 'Lock Box Look up',
	// 					url: '/wells-fargo/lock-box-look-up',
	// 					isActive: pathname?.startsWith('/wells-fargo/lock-box-look-up'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'Clarion Door',
	// 			url: '/clarion-door/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/clarion-door/mappings',
	// 					isActive: pathname?.startsWith('/clarion-door/mappings'),
	// 				},
	// 				{
	// 					title: 'Locations',
	// 					url: '/clarion-door/locations',
	// 					isActive: pathname?.startsWith('/clarion-door/locations'),
	// 				},
	// 				{
	// 					title: 'Lines of Business',
	// 					url: 'clarion-door/lines-of-business',
	// 					isActive: pathname?.startsWith('/clarion-door/lines-of-business'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'InsCipher',
	// 			url: '/inscipher/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/inscipher/mappings',
	// 					isActive: pathname?.startsWith('/inscipher/mappings'),
	// 				},
	// 				{
	// 					title: 'Locations',
	// 					url: '/inscipher/locations',
	// 					isActive: pathname?.startsWith('/inscipher/locations'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'Decus Direct',
	// 			url: '/decus-direct/mappings',
	// 			items: [
	// 				{
	// 					title: 'Mappings',
	// 					url: '/decus-direct/mappings',
	// 					isActive: pathname?.startsWith('/decus-direct/mappings'),
	// 				},
	// 				{
	// 					title: 'Locations',
	// 					url: '/decus-direct/locations',
	// 					isActive: pathname?.startsWith('/decus-direct/locations'),
	// 				},
	// 				{
	// 					title: 'Providers',
	// 					url: '/decus-direct/providers',
	// 					isActive: pathname?.startsWith('/decus-direct/providers'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'Documents',
	// 			url: '/documents/classes',
	// 			items: [
	// 				{
	// 					title: 'Classes',
	// 					url: '/documents/classes',
	// 					isActive: pathname?.startsWith('/documents/classes'),
	// 				},
	// 				{
	// 					title: 'Types',
	// 					url: '/documents/Types',
	// 					isActive: pathname?.startsWith('/documents/types'),
	// 				},
	// 				{
	// 					title: 'Metadata Types',
	// 					url: '/documents/metadata-types',
	// 					isActive: pathname?.startsWith('/documents/metadata-types'),
	// 				},
	// 			],
	// 		},
	// 		{
	// 			title: 'Geovera',
	// 			url: '/geovera/policies',
	// 			items: [
	// 				{
	// 					title: 'Policy Feed',
	// 					url: '/geovera/policies',
	// 					isActive: pathname?.startsWith('/geovera/policies'),
	// 				},
	// 				{
	// 					title: 'Check Feed',
	// 					url: '/geovera/checks',
	// 					isActive: pathname?.startsWith('/geovera/checks'),
	// 				}
	// 			],
	// 		}
	// 	],
	// };
	return (
		<Sidebar {...props}>
			<SidebarHeader>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton size="lg" asChild>
							<Link to="/">
								<div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
									<Flame className="size-4" />
								</div>
								<div className="flex flex-col gap-0.5 leading-none">
									<span className="font-semibold">Fireball</span>
									<span className="">v1.0.0</span>
								</div>
							</Link>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarHeader>
			<SidebarContent>
				<SidebarGroup>
					<SidebarMenu>
						{nav.map((item) => (
							<Collapsible key={item.title} defaultOpen className="group/collapsible">
								<SidebarMenuItem>
									<CollapsibleTrigger asChild>
										<SidebarMenuButton asChild>
											<Link to={item.url} className="font-medium">
												{item.title}
											</Link>
										</SidebarMenuButton>
									</CollapsibleTrigger>
									<CollapsibleContent>
										{item.children?.length ? (
											<SidebarMenuSub>
												{item.children.map((item) => (
													<SidebarMenuSubItem key={item.title}>
														<SidebarMenuSubButton
															asChild
															isActive={pathname?.startsWith(item.url)}
														>
															<a href={item.url}>{item.title}</a>
														</SidebarMenuSubButton>
													</SidebarMenuSubItem>
												))}
											</SidebarMenuSub>
										) : null}
									</CollapsibleContent>
								</SidebarMenuItem>
							</Collapsible>
						))}
					</SidebarMenu>
				</SidebarGroup>
			</SidebarContent>
			<SidebarRail />
		</Sidebar>
	);
}
